import { Capacitor } from '@capacitor/core'
import { Keyboard } from '@capacitor/keyboard'
import { useEffect } from 'react'

/**
 * WKWebView doesn't reliably scroll a focused input back into view once the
 * keyboard has resized the body, unlike Android's WebView. Nudge it ourselves
 * once the keyboard has finished animating in.
 */
const useKeyboardScrollFix = () => {
	useEffect(() => {
		if (Capacitor.getPlatform() !== 'ios') return

		const listenerPromise = Keyboard.addListener('keyboardDidShow', () => {
			const activeElement = document.activeElement
			if (activeElement instanceof HTMLElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
				activeElement.scrollIntoView({ block: 'center', behavior: 'smooth' })
			}
		})

		return () => {
			listenerPromise.then(listener => listener.remove())
		}
	}, [])
}

export default useKeyboardScrollFix
